/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */
(function ($) {
  var lightboxHistory = function () {
    if ($('html').hasClass('history')) {
      if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
      }
      $('.lightbox-link').on('click', function () {
        var pushUrl = $(this).attr('href').replace(location.origin, '');
        window.history.pushState('obj', $(this).attr('href'), pushUrl);
        return true;
      });
      $(window).on('popstate', function () {
        $('.lb-close').trigger('click');
      });
    }
  };

  function createVariables() {
    var headerHeight = $('header.main').outerHeight();
    vein.inject(':root', {
      '--headerHeight': headerHeight + 'px'
    });

    vein.inject(':root', {
      '--vh': $(window).innerHeight() + 'px'
    });
    if ($('.section-title').length) {
      var marginLeft = $('section .container').offset().left;
      vein.inject(':root', {
        '--marginLeft': marginLeft + 'px'
      });
    }

    $('.nav>li').each(function () {

      var maxWidth = $(this).outerWidth();
      $(this).attr('style', '--maxWidth: ' + maxWidth + 'px');

    });

  }
  var Smores = {
    // All pages
    common: {
      init: function () {

        createVariables();

        $(window).load(function () {

          $(".banner img").error(function () {
            $(this).off("error").attr("src", "/wp-content/uploads/2014/09/3-1540x866.jpg");
          });
        });

        if ($(".large-carousel, .autoplay-carousel").length) {

          $(".large-carousel, .autoplay-carousel").owlCarousel({
            navigation: true, // Show next and prev buttons
            slideSpeed: 300,
            paginationSpeed: 400,
            singleItem: true,
            transitionStyle: "fade",
            autoHeight: false
          });
        }
        if ($('.thumbnail-carousel').length) {

          $(".thumbnail-carousel").owlCarousel({
            navigation: true, // Show next and prev buttons
            slideSpeed: 300,
            paginationSpeed: 400,
            singleItem: true,
            transitionStyle: "fade"
          });

        }

        var $menuToggle = $('.navbar-toggle');
        var $body = $('body');
        var $nav = $('nav');
        var $expand = $('.menu-expand');
        $menuToggle.on('click', function () {

          $body.toggleClass('menu-open');
          $nav.slideToggle(500);
          return false;

        });
        $expand.on('click', function () {

          $nav.toggleClass('expand');
          $expand.toggleClass('expanded');
          return false;

        });

        $('.panel-heading a').on('click', function (e) {

          e.preventDefault();

          var headerHeight = $('header').outerHeight();
          var parent = $(this).parents('.panel');
          var panel = $($(this).parents('.panel-heading')).next('.panel-collapse');

          $(panel).slideToggle(300);

          // setTimeout(function () {

          //   $('html, body').animate({
          //     scrollTop: $(parent).offset().top - headerHeight
          //   }, 0);

          // }, 30);

          return false;

        });

        $('.mobile-tooltip').on('click', function () {

          $(this).fadeOut(300);
          return false;

        });

        $('.call-toggle').on('click', function () {

          $('body').addClass('call-modal-open');

          return false;

        });

        $('#contact-widget .close').on('click', function () {

          $('body').removeClass('call-modal-open');

          return false;

        });

        $(document).on('click','.search-nav-icon',function(){

          // if(!$(".search-menu").hasClass("search-menu-visible")){
          //   $(".search-menu").addClass("search-menu-visible");
          // } else{
          //   $(".search-menu").removeClass("search-menu-visible");
          // }
          if($(".search-menu").is( ":hidden" )){
            $(".search-menu").slideDown();
            $(".search-nav-icon .fa-search").fadeOut( "fast", function() {
              $(".search-nav-icon-close").fadeIn();
            });
          }else {
            $(".search-menu").slideUp( "slow", function() {
              $(".search-menu").hide();
            });
            $(".search-nav-icon-close").fadeOut( "fast", function() {
              $(".search-nav-icon .fa-search").fadeIn();
            });
            
          }
        });
        
        $(document).on('change','#searchform-nav',function(){
          var selected_value = $("input[name='search-type']:checked").val();
          var other_value = $("input[type='radio']:not(:checked)").val();
          $('.search-form').removeClass(other_value);
          $('.search-form').addClass(selected_value);
        });

      

        $('.content-search i').on('click', function (e) {
          e.stopPropagation();

          var searchValue = $('.content-search input').val();
          
          if (searchValue.length === 0) {

            $('.content-search .form-control').closest('.input-field').addClass('error');
          }
          else {

            $('.search-menu form').trigger('submit');
          }
          
          return false;
        });

        $('.content-search input').keypress((e) => {
          // Keyboard Enter
          if (e.which === 13) {
            e.stopPropagation();

            var searchValue = $('.content-search input').val();
            
            if (searchValue.length === 0) {
  
              $('.content-search .form-control').closest('.input-field').addClass('error');
            }
            else {
  
              $('.search-menu form').trigger('submit');
            }
            
            return false;
          }
      })
        
        $('.product-search i').on('click', function (e) {
          e.stopPropagation();
          
          $('#search-product-num').closest('.input-field').removeClass('error');
          $('#search-tile-region').closest('.input-field').removeClass('error');
          
          var region = $('#search-tile-region').val();
          var tileNum = $('#search-product-num').val();
          
          if (tileNum.length === 0) {
            $('#search-product-num').closest('.input-field').addClass('error');
            
          }
          if (!region) {
           
            $('#search-tile-region').closest('.input-field').addClass('error');
         
          }
          
          if(region !== null && tileNum !== "") {

            window.location = '/browse-tile/tile-results/?region='+ region
            + '&search=' + tileNum + '&pg=1';
          }
         
          return false;

        });

        $('#search-tile-region')

      

        $body.on('click', function () {

          var wrapper = $('.search-nav');

          if ($(wrapper).hasClass('search-typing')) {
            $(wrapper).removeClass('search-typing');

          }
        });

        $('.entry-content p').each(function () {

          var text = $(this).html();
          var string = '&nbsp;';

          if (string == text) {

            $(this).remove();
          }

        });

        if ($('.entry-content').length) {

          var title = $('.banner h1.alt.white').text();
          var title2 = $('.entry-content h2').first().text();

          if (title == title2) {
            $('.entry-content h2').first().remove();

          }
        }

        if ($('.sidebar').length) {
          var headerTop = ($('header').outerHeight() * .75);

          $('.sidebar .content').hcSticky({
            stickTo: '.sidebar',
            top: headerTop,
            responsive: {
              767: {
                disable: true
              }
            }

          });

        }

        var resizeTimer;
        var resizeEvent;
        $(window).on('resize', function (e) {
          clearTimeout(resizeTimer);
          resizeEvent = true;
          resizeTimer = setTimeout(function () {

            createVariables();

          }, 250);
        });

        $('.nav > li a').on('click', function () {

          var parent = $(this).parents('li.dropdown.open').attr('id');
          Cookies.remove('parents');
          Cookies.set('parents', parent);
        });
        $('footer .menu li a').on('click', function () {

          var parent = $($(this).parents('footer .menu > li.dropdown').find('.dropdown-toggle')).attr('title');
          var parentID = $('.nav li.dropdown > a[title="' + parent + '"]').parents('li.dropdown').attr('id');

          Cookies.remove('parents');
          Cookies.set('parents', parentID);
          //          console.log(parent)
          //          console.log(parentID)
        });

        if ((Cookies.get('parents') != 'undefined') && ($('body').not('.home').length == 1)) {

          var parent = Cookies.get('parents');

          $('.nav li.active').not('.' + parent).removeClass('active');
          $('.nav li.' + parent).addClass('active');
          $('.sidebar li').not('.' + parent);
          $('.sidebar li.' + parent).addClass('parent-nav');
        }

        if (window.hcSticky) {
          window.hcSticky('.header-container', {
            stickTo: '.body',
            responsive: {
              767: {
                disable: true
              }
            }
          });
        }

        $('.socials a').on('click', function (e) {
          e.preventDefault();
          var poplink = $(this).attr('href');
          newwindow = window.open(poplink, 'name', 'height=800,width=1200');
          if (window.focus) {
            newwindow.focus()
          }
          return false;
        });

        $('.sidebar-results .list-group-item, .sidebar-results .thumbnail').on('click', function (e) {
          e.preventDefault();
          $(this).toggleClass('selected');
        });

        $("body").tooltip({
          selector: '[data-toggle=tooltip]'
        });

        var resize = function () {
          //          if ($(window).width() > 1200) {
          //            $('#customer-service,#design-centers').not(".binded").addClass("binded").toggle();
          //            $('#show-customer-service').not(".binded").addClass("binded").on('click', function () {
          //              $('#customer-service').slideToggle();
          //            });
          //            $('#show-design-centers').not(".binded").addClass("binded").on('click', function () {
          //              $('#design-centers').slideToggle();
          //            });
          //            $(".large-carousel div picture").each(function () {
          //              var myImg = $(this);
          //              var mySrc = myImg.find('.large').attr('srcset');
          //              var myLi = myImg.parents('div.active');
          //              myImg.hide();
          //              myLi.css({
          //                'background-image': 'url(' + mySrc + ')',
          //                'background-repeat': 'no-repeat',
          //                'background-size': 'cover',
          //                'background-position': 'center center'
          //              });
          //            });
          //          } else {
          //            $('.binded').removeClass('binded').unbind();
          //            $('#customer-service,#design-centers').show();
          //            $(".large-carousel div picture").each(function () {
          //              var myImg = $(this);
          //              myImg.show();
          //            });
          //          }
          //          $('.cta-equal-height').css("height", "auto").equalHeights();
          //          $('.cta-equal-height-2').css("height", "auto").equalHeights();
          //          $('.profile-equal-height a').css("height", "auto").equalHeights();
          //          $('.match-me').equalHeights();
        };
        //        $(window).load(function () {
        //          $(window).resize(resize);
        //          resize();
        //          $(".blog-lightbox").each(function () {
        //            $(this).attr('data-lightbox', 'blog');
        //          });
        //        });

        $(".blog-lightbox, .gallery-item a").each(function () {
          $(this).attr('data-lightbox', 'blog');
        });

        // $('.pardot-signup').validate({
        //   rules: {
        //     email: {
        //       required: true,
        //       email: true
        //     },
        //     firstName: {
        //       required: true
        //     },
        //     lastName: {
        //       required: true
        //     },
        //     userState: {
        //       required: true
        //     }
        //   },
        //   messages: {
        //     email: {
        //       required: 'Please enter an email address',
        //       email: 'Please enter a valid email address'
        //     },
        //     firstName: 'Please enter your first name',
        //     lastName: 'Please enter your last name',
        //     userState: 'Please select a state'
        //   },
        //   submitHandler: function (form) {
        //     $.ajax({
        //       type: 'post',
        //       url: '/wp-content/themes/eagl/lib/pardot-signup.php',
        //       data: $(form).serialize()
        //     }).done(function (data) {
        //       console.log(data);
        //       $(form).find('.alert').remove();
        //       $(form).append('<div class="alert alert-success" style="margin-top: 15px;">' + data + '</div>');
        //       window.location = '/contact/thank-you';
        //       ga('send', 'event', 'Pardot Form', 'Submit');
        //     }).fail(function (data) {
        //       console.log(data);
        //       $(form).find('.alert').remove();
        //       $(form).append('<div class="alert alert-warning" style="margin-top: 15px;">' + data.responseText + '</div>');
        //     });
        //   }
        // });
        $('#searchForm').validate({

          search: {
            required: true

          }

        });
        $('#initialFilters').validate({

          profile: {
            required: true

          },
          weight: {
            required: true

          }

        });
        $('.contact-form').validate({
          rules: {
            email: {
              required: true,
              email: true
            },
            firstName: {
              required: true
            },
            lastName: {
              required: true
            },
            state: {
              required: true
            }
          },
          messages: {
            email: {
              required: 'Please enter an email address',
              email: 'Please enter a valid email address'
            },
            firstName: 'Please enter your first name',
            lastName: 'Please enter your last name',
            state: 'Please select a state'
          },
          submitHandler: function (form) {
            $.ajax({
              type: 'post',
              url: '/wp-content/themes/eagl/lib/contact-form.php',
              data: $(form).serialize()
            }).done(function (data) {
              console.log(data);
              $(form).find('.alert').remove();
              $(form).append('<div class="alert alert-success" style="margin-top: 15px;">' + data + '</div>');
              window.location = '/contact/thank-you';
              ga('send', 'event', 'Contact Form', 'Submit');
            }).fail(function (data) {
              console.log(data);
              $(form).find('.alert').remove();
              $(form).append('<div class="alert alert-warning" style="margin-top: 15px;">' + data.responseText + '</div>');
            });
          }
        });

        window.setTimeout(function () {
          $('footer .dropdown .dropdown').hoverIntent(function () {
            $(this).children('.dropdown-menu').slideDown(400, function () {
              $(this).css('pointer-events', 'all');
            });
          }, function () {
            $(this).children('.dropdown-menu').css('pointer-events', 'none').slideUp(400);
          });
        }, 2000);

      },
      initVideo: function () {
        console.log("before");
      }
    },
    single_product: {
      init: function () {
        $("#print-image").on('click', function (e) {
          e.preventDefault();
          var img = window.open(this.getAttribute("data-print"));
          img.print();
          ga('send', 'event', 'Product Page', 'Image Print');
        });
        lightboxHistory();
        $('.to-print').on('click', function (e) {
          e.preventDefault();

          var target = $(this).attr('href');

          $('body').addClass('print');
          $(target).addClass('printing');
          window.print();

          setTimeout(function () {

            $('body').removeClass('print');
            $(target).removeClass('printing');

          }, 2000);

          return false;

        });

        var $loader = '<div class="loader-container"><div><p>Generating PDF <i class="fas fa-pdf"></i></p><div class="spinner"></div></div></div>';

        $('.to-pdf').on('click', function () {

          $('body').append($loader);
          var target = $(this).attr('href');
          var title = $('.banner h1').text();
          var targetNice = target.replace('#', '');
          var element = document.getElementById(targetNice);
          var fileTitle = $.trim(title).replace(/\-|\ /g, '_');
          var fileTarget = $.trim(targetNice).replace(/\-|\ /g, '_');
          var filename = fileTitle + '-' + fileTarget + '.pdf';

          html2pdf(element, {
            filename: filename,
            margin: .5,
            image: {
              type: 'jpeg',
              quality: 1
            },
            html2canvas: {
              dpi: 300,
              letterRendering: true
            },
            jsPDF: {
              unit: 'in',
              format: 'letter',
              orientation: 'portrait'
            }
          });

          setTimeout(function () {
            //                $('.hidden-pdf').remove();
            $('.loader-container').fadeOut('500').delay('500').remove();

          }, 1500);

          return false;
        });

      }
    },
    // Home page
    home: {
      init: function () {

        var vid = document.getElementById("bg");
        var vid2 = document.getElementById("bg-mobile");

        $(window).load(function () {

          vid.play();
          vid2.play();

        });

      }
    },
    page_browse_tile: {
      init: function () {

        if ($(window).width() < 768) {

          var eventsHandler;

          eventsHandler = {
            haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
            init: function (options) {
              var instance = options.instance,
                initialScale = 1,
                pannedX = 0,
                pannedY = 0
              // Init Hammer
              // Listen only for pointer and touch events
              this.hammer = Hammer(options.svgElement, {
                inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
              })
              // Enable pinch
              this.hammer.get('pinch').set({
                enable: true
              })
              // Handle double tap
              this.hammer.on('doubletap', function (ev) {
                instance.zoomIn()
              })

              //
              //                        $('.mobile #zoomInButton').on('click', function () {
              //
              //                            instance.zoomIn();
              //                            return false;
              //
              //
              //                        });
              //                        $('.mobile #zoomOutButton').on('click', function () {
              //
              //                            instance.zoomOut();
              //                            return false;
              //
              //
              //                        });
              // Handle pan
              this.hammer.on('panstart panmove', function (ev) {
                // On pan start reset panned variables
                if (ev.type === 'panstart') {
                  pannedX = 0
                  pannedY = 0
                }
                // Pan only the difference
                instance.panBy({
                  x: ev.deltaX - pannedX,
                  y: ev.deltaY - pannedY
                })
                pannedX = ev.deltaX
                pannedY = ev.deltaY
              })
              // Handle pinch
              this.hammer.on('pinchstart pinchmove', function (ev) {
                // On pinch start remember initial zoom
                if (ev.type === 'pinchstart') {
                  initialScale = instance.getZoom()
                  instance.zoom(initialScale * ev.scale)
                }
                instance.zoom(initialScale * ev.scale)
              })
              // Prevent moving the page on some devices when panning over SVG
              options.svgElement.addEventListener('touchmove', function (e) {
                e.preventDefault();
              });
            },
            destroy: function () {
              this.hammer.destroy()
            }

          }

          var map = svgPanZoom(document.querySelector("#tileMap"), {
            viewportSelector: '.svg-pan-zoom_viewport',
            panEnabled: true,
            controlIconsEnabled: false,
            zoomEnabled: true,
            mouseWheelZoomEnabled: false,
            minZoom: 1,
            maxZoom: 5,
            fit: true,
            center: true,
            refreshRate: 120,
            //              beforePan: beforePan,
            customEventsHandler: eventsHandler,
          });

        }

        $('input[name="search"]').keyup(function () {
          tmpval = $(this).val();
          if (tmpval == '') {
            $(this).addClass('empty');
            $(this).removeClass('not-empty');
          } else {
            $(this).addClass('not-empty');
            $(this).removeClass('empty');
          }
        });

        $('#initialFilters select').on('change', function () {
          tmpval = $(this).val();
          if (tmpval == 'placeholder') {
            $(this).addClass('empty');
            $(this).removeClass('not-empty');
          } else {
            $(this).addClass('not-empty');
            $(this).removeClass('empty');
          }

          if ($('#initialFilters .not-empty').length > 1) {

            $('#filter-submit').removeAttr('disabled');
          }
        });

      }
    },
    // Tile Results Page ( ID is 83 )
    page_id_83: {
      init: function () {

        function getParameterByName(name) {
          name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
          var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
          return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        }
        var searchParameter = getParameterByName('search');
        if (searchParameter === true) {
          $('#loadMoreResults').hide();
        }
        console.log('confirmation of correct page ID');
        $('input[name="search"]').keyup(function () {
          tmpval = $(this).val();
          if (tmpval == '') {
            $(this).addClass('empty');
            $(this).removeClass('not-empty');
          } else {
            $(this).addClass('not-empty');
            $(this).removeClass('empty');
          }
        });

        $('.select-facade').on('click', function (e) {
          e.stopPropagation();
          var wrapper = $(this).parents('.facade-group');
          $('.facade-group').not($(wrapper)).removeClass('open');
          $(wrapper).toggleClass('open');
        });
        $('body').on('click', function (e) {

          //        e.stopPropagation();
          $('.facade-group.open').removeClass('open');

        });

        var headerTop = ($('header').outerHeight() * .75);

        var $sidebarContent = $('.sidebar-results .content');

        if ($sidebarContent.hcSticky) {
          $sidebarContent.hcSticky({
            stickTo: '.sidebar-results',
            top: headerTop,
            responsive: {
              767: {
                disable: true
              }
            }
          });
        }
      }
    },
    // Contact page (Page ID is 65)
    page_id_65: {
      init: function () {

        // Cache Input Elements
        var $input = {
          'projectType': $('#project-type'),
          'tileSample': $('#tile-sample'),
          'brochure': $('#brochure'),
          'country': $('#country'),
          'provinceItem': $('#provinceItem'),
          'stateItem': $('#stateItem'),
          'zip': $('#provinceItem').next(),
          'profession': $('#profession'),
          'company': $('#company'),
          'inquiry': $('input:radio[name="inquiry"]'),
        };

        function resetInquiryFields() {
          $input.projectType.removeClass('hide');

          $input.tileSample.addClass('hide');
          $input.brochure.addClass('hide');

          // Don't require location info
          setRequired($input.zip, 'input', false);
          setRequired($input.stateItem, 'input', false);
          setRequired($input.provinceItem, 'input', false);
        }

        function setRequired($field, selector, required) {
          $field.find(selector).prop('required', required);

          if (required) {
            $field.find('.required').removeClass('hide');
          } else {
            $field.find('.required').addClass('hide');
          }
        };

        $input.inquiry.change(function () {
          var stateHidden = $input.stateItem.hasClass('hide');

          switch ($(this).val()) {
            case 'Have a Representative Contact Me':
              resetInquiryFields();
            break;

            case 'Request Literature':
              $input.brochure.removeClass('hide');

              $input.tileSample.addClass('hide');
              $input.projectType.addClass('hide');
              // $input.zip.removeClass('hide')

              // Require location info
              setRequired($input.zip, 'input', true);
              setRequired($input.stateItem, 'select', !stateHidden);
              setRequired($input.provinceItem, 'select', stateHidden);
            break;

            case 'Request a Tile Sample':
              $input.tileSample.removeClass('hide');

              $input.projectType.addClass('hide');
              $input.brochure.addClass('hide');
              // $input.zip.removeClass('hide')

              // Require location info
              setRequired($input.zip, 'input', true);
              setRequired($input.stateItem, 'select', !stateHidden);
              setRequired($input.provinceItem, 'select', stateHidden);
            break;

            default:
            break;
          }
        });

        function onProfessionChange(propagate) {
          if ($("#profession :selected").text() === 'Homeowner') {
            $input.company.addClass('hide');
          } else {
            $input.company.removeClass('hide');
          }
        }

        function onCountryChange(propagate) {
          var stateHidden = $('#country :selected').text() === 'Canada';
          if (stateHidden) {
            $input.provinceItem.removeClass('hide');
            $input.stateItem.addClass('hide');
          } else {
            $input.stateItem.removeClass('hide');
            $input.provinceItem.addClass('hide');
          }

          if ($input.inquiry.val() !== 'Have a Representative Contact Me') {
            setRequired($input.stateItem, 'select', !stateHidden);
            setRequired($input.provinceItem, 'select', stateHidden);
          }
        }

        $input.profession.change(onProfessionChange);
        $input.country.change(onCountryChange);

        window.setTimeout(function () {
          resetInquiryFields();
          $input.profession.change();
          $input.country.change();
        }, 100);
      },
    },
    page_id_4760: {
      init: function () {
        $('#profession').change(function () {
          if ($("#profession :selected").text() === 'Homeowner') {
            $('#company').addClass('hide');
          } else {
            if ($('#company').hasClass('hide')) {
              $('#company').removeClass('hide');
            }
          }
        });
      },
    },
    // Product Search Results
    page_template_template_tile_results_php: {
      init: function () {
        $('body').on('click', '.enlarge-image', function (e) {
          e.preventDefault();
          $(this).parent().find('.thumbnail-carousel .item a.lightbox-link').eq(0).trigger('click');
        });
      }
    },
    page_product_brochures: {
      init: function() {
        var $regionFilter = $('#region-filter');
        var $regionBrochures = $('#region-brochrues');

        $regionFilter.change(function () {
          var slug = $(this).val();

          $regionBrochures.attr('class', 'brochures ' + slug);

          if (slug === 'all') {
            $regionBrochures.children().attr('style', '');
          } else {
            var $theBoys = $regionBrochures.find('[data-region=' + slug + ']');
            $theBoys
              .show()
              .siblings()
              .not($theBoys)
              .hide();
          }
        })
      }
    }
  };
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var namespace = Smores;
      funcname = (funcname === undefined) ? 'init' : funcname;
      if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      UTIL.fire('common');
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
      });
    }
  };
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
